import { isArr } from '../../../global-utils';
import { resolveTimeBasedWrapper } from '../../../global-utils/vmFunctions/dateTime';

export const filterTimeBasedComponents = (components) => (isArr(components)
  ? (components?.filter((component) => {
    const { startsAt, endsAt, isDisabled } = component;

    // If it has no time window, assume it should be shown
    if (!startsAt && !endsAt) return true;
    if (isDisabled) return false;

    // Use the shared utility
    return resolveTimeBasedWrapper({ startsAt, endsAt });
  })) : components);
